
import { Outlet } from "react-router-dom";
import { Sidebar } from "../include/Sidebar";
import { useSelector } from "react-redux";
import { isRole, isRoleType } from "../../redux/selectors/authSelector";
import { toastMessage, toastShow } from "../../redux/selectors/toastSelector"
import Toast from "../common/Toast";
import ApprovalModal from "../ApprovalModal";

const SidebarLayout = () => {
  const toast_show = useSelector(toastShow);
  const toast_msg = useSelector(toastMessage);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  const is_verified = useSelector((state) => state.auth?.data?.user?.school_id?.is_school_verified);
  const school = useSelector((state) => state.auth?.data?.user?.school_id);
  const is_profile_completed = useSelector((state) => state.auth?.data?.user?.is_profile_completed);
  const roleType = useSelector((state) => state.auth?.data?.user?.role_type);

  const showApprovalModal =
    (roleType === "schoolsubadmin" && !is_verified && is_profile_completed) ||
    (role === "schooladmin" && !is_verified && is_profile_completed);

  return (
    <div className="flex p-[30px]">
      <Sidebar />
      <Toast show={toast_show} message={toast_msg} />
      <div className="flex-1 min-h-screen md:ml-[15rem] ml-[5rem]">
        {showApprovalModal && <ApprovalModal isVisible={true} data={school} />}
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SidebarLayout;

